import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
//import { QuizBankService, QuizBankServiceSymbol } from './services/quiz-bank-service';
import { quizStateModule } from './state2'
import { quizServiceModule } from './services2'
import { quizDslModule } from './dsl'
import { QuizPlayerModule } from './quiz-player-module';

const quizModule = new ContainerModule((bind) => {
  // bind<QuizBankService>(QuizBankServiceSymbol).to(QuizBankService);

  // bind(ClearQuizResultsState).toSelf().inSingletonScope();
  // bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(ClearQuizResultsState));

  // player module
  bind(PlayerModuleSymbol).to(QuizPlayerModule)
});

export const quizModules = [
  quizModule,
  quizStateModule,
  quizServiceModule,
  quizDslModule
]
